var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47504 25.4285C6.08864 25.8432 5.87828 26.3916 5.88828 26.9583C5.89828 27.525 6.12786 28.0658 6.52864 28.4665C6.92943 28.8673 7.47014 29.0969 8.03685 29.1069C8.60356 29.1169 9.15203 28.9065 9.56671 28.5201L16.7417 21.3451L13.65 18.2535L6.47504 25.4285Z",
    fill: "url(#paint0_linear_1_807)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4027 12.1334L27.5284 10.5146L29.1666 7.35488L27.6402 5.82849L24.4804 7.46669L22.8617 10.5875L19.0603 14.3938L20.6013 15.9396L24.4027 12.1334Z",
    fill: "url(#paint1_linear_1_807)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0881 20.4167H24.7916C24.2749 20.4196 23.7629 20.5151 23.2798 20.6986L14.3159 11.7104C14.4933 11.2295 14.5838 10.7209 14.5833 10.2083L14.5541 9.91667C14.5136 9.20656 14.2986 8.51739 13.9282 7.91018C13.5578 7.30297 13.0434 6.79645 12.4305 6.43546C11.8176 6.07447 11.1252 5.87015 10.4146 5.84059C9.7039 5.81103 8.99692 5.95714 8.35619 6.26598L11.2729 9.18265C11.4194 9.33191 11.5322 9.51096 11.6034 9.70765C11.6848 9.93003 11.7107 10.1689 11.6791 10.4036C11.6474 10.6382 11.5591 10.8616 11.4217 11.0545C11.2843 11.2474 11.1021 11.4039 10.8907 11.5106C10.6792 11.6173 10.445 11.6708 10.2083 11.6667C10.0415 11.6615 9.87694 11.6269 9.72217 11.5646C9.52686 11.4928 9.34822 11.382 9.19717 11.2389L6.2805 8.32223C5.96873 8.96283 5.81998 9.67051 5.84746 10.3824C5.87494 11.0943 6.07781 11.7884 6.43804 12.4031C6.79827 13.0177 7.30472 13.5339 7.91241 13.9058C8.5201 14.2777 9.21022 14.4937 9.92147 14.5347L10.2083 14.5833C10.725 14.5804 11.237 14.4849 11.7201 14.3014L20.7083 23.2556C20.5186 23.7456 20.4197 24.2662 20.4166 24.7917L20.4458 25.0833C20.5266 26.1822 21.019 27.21 21.8246 27.9616C22.6303 28.7132 23.6898 29.1331 24.7916 29.1375C25.4407 29.1369 26.081 28.9872 26.6631 28.7L23.7465 25.7833C23.6101 25.6373 23.5043 25.4654 23.4354 25.2778C23.3581 25.0593 23.334 24.8256 23.3651 24.5959C23.3962 24.3663 23.4816 24.1473 23.6141 23.9573C23.7467 23.7672 23.9227 23.6115 24.1274 23.5029C24.3322 23.3944 24.5599 23.3363 24.7916 23.3333C24.9584 23.3385 25.1229 23.3731 25.2777 23.4354C25.476 23.501 25.6559 23.6126 25.8027 23.7611L28.7194 26.6778C29.0416 26.036 29.199 25.3241 29.1773 24.6063C29.1557 23.8885 28.9557 23.1873 28.5954 22.5661C28.2351 21.9449 27.7259 21.4231 27.1136 21.0479C26.5013 20.6726 25.8052 20.4557 25.0881 20.4167Z",
    fill: "url(#paint2_linear_1_807)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_807",
    x1: 5.88794,
    y1: 23.6804,
    x2: 16.7417,
    y2: 23.6804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02AAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CDAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_807",
    x1: 19.0603,
    y1: 10.884,
    x2: 29.1666,
    y2: 10.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_807",
    x1: 5.84424,
    y1: 17.4872,
    x2: 29.1793,
    y2: 17.4872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C56EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/CreateIcon.ea80e1ecec5a3596303b9d33c5ddf8d4.svg";
export { ForwardRef as ReactComponent };